/*
  Redesign 2026: pagina produsului (Planner de nuntă și Premium).
  - zilele rămase până la nunta demo, pe coperta și în replicile foilor;
  - taburile cu foile plannerului;
  - indiciul „Glisează tabelul” apare doar când tabelul chiar iese din cadru;
  - bara de cumpărare de pe telefon apare după ce butonul real iese din ecran;
  - bara de sub 750px oglindește starea butonului real și prețul.
  Butonul din bară trimite același formular de produs (atributul form).
*/
(function () {
  if (window.mcbPlannerInit) return;
  window.mcbPlannerInit = true;

  function toate(sel, radacina) {
    return Array.prototype.slice.call((radacina || document).querySelectorAll(sel));
  }

  function zilePana(data) {
    var d = new Date(data + 'T00:00:00');
    var azi = new Date();
    azi.setHours(0, 0, 0, 0);
    return Math.round((d - azi) / 864e5);
  }

  /* „de” doar de la 20 în sus (5 zile, 20 de zile, 101 zile, 120 de zile) */
  function zileText(n) {
    var r = n % 100;
    return n + (n >= 20 && (r === 0 || r >= 20) ? ' de zile' : ' zile');
  }

  function zile() {
    toate('[data-days-to]').forEach(function (el) {
      var n = zilePana(el.getAttribute('data-days-to'));
      el.textContent = n < 0 ? 'nunta a avut loc' : (n === 1 ? 'mai este o zi' : 'mai sunt ' + zileText(n));
    });
    toate('[data-v1-days]').forEach(function (el) {
      var n = zilePana(el.getAttribute('data-v1-days'));
      if (n >= 0) el.textContent = (n === 1 ? 'Mai este o zi' : 'Mai sunt ' + zileText(n)) + ' până la nuntă';
    });
    toate('[data-v1-num]').forEach(function (el) {
      var n = zilePana(el.getAttribute('data-v1-num'));
      if (n >= 0) el.textContent = n;
    });
  }

  function indicii() {
    toate('.mcb .xl-hint').forEach(function (h) {
      var sc = h.nextElementSibling;
      if (sc) h.classList.toggle('on', sc.scrollWidth > sc.clientWidth + 2);
    });
  }

  function taburi() {
    toate('.mcb [data-tabs]').forEach(function (bara) {
      var sectiune = bara.closest('section') || bara.parentNode;
      bara.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !bara.contains(b)) return;
        toate('button', bara).forEach(function (x) {
          x.classList.toggle('on', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        toate('.panel', sectiune).forEach(function (p) {
          p.classList.toggle('on', p.id === b.getAttribute('data-p'));
        });
        indicii();
      });
      toate('button', bara).forEach(function (x) {
        x.setAttribute('aria-pressed', x.classList.contains('on') ? 'true' : 'false');
      });
    });
  }

  function oglindeste(bara, buton) {
    var copie = bara.querySelector('button');
    var suma = bara.querySelector('[data-mcb-bara-suma]');
    var pret = document.getElementById(bara.getAttribute('data-mcb-bara-pret'));
    var cumpara = bara.getAttribute('data-text-cumpara');
    var implicit = copie.textContent;
    function sync() {
      var text = (buton.querySelector('span') || buton).textContent.trim();
      var sursa = pret && pret.querySelector('.price');
      copie.textContent = text === cumpara ? implicit : text;
      copie.disabled = buton.disabled;
      copie.classList.toggle('loading', buton.classList.contains('loading'));
      if (buton.hasAttribute('aria-disabled')) copie.setAttribute('aria-disabled', buton.getAttribute('aria-disabled'));
      else copie.removeAttribute('aria-disabled');
      if (sursa) suma.textContent = sursa.textContent;
    }
    var observator = new MutationObserver(sync);
    var ce = { attributes: true, childList: true, characterData: true, subtree: true };
    observator.observe(buton, ce);
    if (pret) observator.observe(pret, ce);
    sync();
  }

  function baraCumparare() {
    toate('[data-mcb-buybar]').forEach(function (bara) {
      var buton = document.getElementById(bara.getAttribute('data-mcb-buybar-for'));
      if (buton && bara.hasAttribute('data-text-cumpara')) oglindeste(bara, buton);
      if (!buton || !('IntersectionObserver' in window)) return;
      // Marginea de jos „infinită”: butonul contează ca vizibil cât timp nu a ieșit
      // pe sus, deci și un salt cu ancora peste el schimbă starea.
      new IntersectionObserver(
        function (e) {
          bara.classList.toggle('on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        },
        { rootMargin: '0px 0px 100000px 0px' }
      ).observe(buton);
    });
  }

  function porneste() {
    zile();
    taburi();
    indicii();
    baraCumparare();
    window.addEventListener('resize', indicii);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }
})();
